import {
  kickFromSpace,
  lockPerson,
  muteForMe,
  unlockPerson,
  unmuteForAll,
  unmuteForMe,
} from "slices/spaceSlice";
import { disableShout, enableShout, muteForAll } from "slices/spaceSlice";

const spaceOptions = ({ meAdmin, luid = null, peopleMedia }) => {
  let options = [];
  if (peopleMedia[luid] === undefined) return;

  options = peopleMedia[luid].mutedForMe
    ? [
        {
          text: "Mute For Me",
          active: true,
          action: () => unmuteForMe(luid),
          stayOpen: true,
        },
      ]
    : [
        {
          text: "Mute For Me",
          action: () => muteForMe(luid),
          stayOpen: true,
        },
      ];

  if (meAdmin) {
    options = options.concat(
      peopleMedia[luid].muted
        ? [
            {
              text: "Mute For All",
              active: true,
              action: () => unmuteForAll(luid),
              stayOpen: true,
            },
          ]
        : [
            {
              text: "Mute For All",
              action: () => muteForAll(luid),
              stayOpen: true,
            },
          ]
    );

    options = options.concat(
      peopleMedia[luid].shoutable
        ? [
            {
              text: "Podium Disabled",
              action: () => disableShout(luid),
              stayOpen: true,
            },
          ]
        : [
            {
              text: "Podium Disabled",
              active: true,
              action: () => enableShout(luid),
              stayOpen: true,
            },
          ]
    );

    options = options.concat(
      peopleMedia[luid].locked
        ? [
            {
              text: "Lock Position",
              active: true,
              action: () => unlockPerson(luid),
              stayOpen: true,
            },
          ]
        : [
            {
              text: "Lock Position",
              action: () => lockPerson(luid),
              stayOpen: true,
            },
          ]
    );

    options = options.concat([
      {
        text: "Kick From Space",
        danger: true,
        action: () => kickFromSpace(luid),
      },
    ]);
  }

  return options;
};

export default spaceOptions;
